<template>
	<div style="width: 100%; height: 400px;">
		<l-map ref="map" :zoom="zoom" :center="center" @click="onClick">
			<l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
			<l-marker :lat-lng="marker"></l-marker>
		</l-map>
	</div>
  </template>
  
  <script>
  	import L from 'leaflet';
	import { Icon } from 'leaflet';
	import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
	import 'leaflet/dist/leaflet.css';
	

  export default {
	name: "mapirMarker",
	components: {
		LMap,
		LTileLayer,
		LMarker
	},
	data() {
	  return {
		zoom:16,
		lat_lng:[51.33807603569022, 35.699778973028806],
		center: this.lat_lng,
		url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
		attribution:'&copy; ',
		marker: this.lat_lng,
	  };
	},
	props: {
      latlng: {
        default:[51.33807603569022, 35.699778973028806],
      },
    },
	mounted(){
		if(this.latlng.length == 2){
			this.lat_lng[0] = this.latlng[0];
			this.lat_lng[1] = this.latlng[1];
		}
		delete Icon.Default.prototype._getIconUrl;
		Icon.Default.mergeOptions({
			iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
			iconUrl: require('leaflet/dist/images/marker-icon.png'),
			shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
		});
        this.center = L.latLng(this.lat_lng[1], this.lat_lng[0])
        this.marker = L.latLng(this.lat_lng[1], this.lat_lng[0])
	},
	methods: {
		onClick(e) {
			this.marker = e.latlng;
			var val = [e.latlng.lng, e.latlng.lat];
			this.$emit('lat_lngFunc', val);
		},
	}
  };
  </script>